// extracted by mini-css-extract-plugin
export default {"studio-leaderboard-form":"studio-leaderboard-form_wKyKL"};